import React from 'react'
import PriceRowPointsSpend from '../PriceRowPointsSpend'
import Group from 'components/utils/Group'
import PriceRowPrice from '../PriceRowPrice'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import styled from 'styled-components'
import LoyaltyPointsEarnRatio from 'loyalty/components/Earn/LoyaltyPointsEarnRatio'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const OrText = styled(BodyText)`
  line-height: ${rem(20)};
`

interface Props {
  price?: number;
  points?: number;
  direction: 'horizontal' | 'stack';
  size: 'S' | 'L';
  earnRatio?: number;
}

function PriceRowMerchandisePriceStack(props: Props) {
  const { price, points, size, direction, earnRatio } = props

  return <VerticalSpacer gap={4}>
    <Group
      direction={direction === 'horizontal' ? 'horizontal' : 'vertical'}
      gap={direction === 'horizontal' ? 8 : 0}
      verticalAlign={direction === 'horizontal' ? 'start' : undefined}
    >
      {!!price && <PriceRowPrice price={price} size={size} saleUnit="" />}
      <Group direction="horizontal" gap={8} verticalAlign="start">
        {!!price && !!points && <OrText variant="small" colour="neutral-three">or</OrText>}
        {!!points && <PriceRowPointsSpend points={points} size={size} />}
      </Group>
    </Group>
    {!!earnRatio && <LoyaltyPointsEarnRatio ratio={earnRatio} />}
  </VerticalSpacer>
}

export default PriceRowMerchandisePriceStack
